export const relaySubtypeKeysMap = new Map([
    ['TPG', 'Thermostat'],
    ['NVG', 'Starter pack'],
]);
